import {useEffect} from 'react';
import {useDispatch} from 'react-redux';

import {useAppSelector} from '@/redux/config';
import {fetchKeywordData} from '@/redux/v1/keywordData/actions';
import {
  selectDataById,
  selectErrorById,
  selectStatusById,
} from '@/redux/v1/keywordData/reducer';

export const useKeywordData = (keywordId: string) => {
  const dispatch = useDispatch();

  const status = useAppSelector(selectStatusById(keywordId));
  const data = useAppSelector(selectDataById(keywordId));
  const error = useAppSelector(selectErrorById(keywordId));

  useEffect(() => {
    if (keywordId) {
      // @ts-expect-error ...
      dispatch(fetchKeywordData(keywordId));
    }
  }, [dispatch, keywordId]);

  return {status, data, error};
};
